import useEquipmentModel from '@/pages/Equipment/pages/EquipmentModels/hooks/useEquipmentModel.ts'
import confirmService from '@/services/ConfirmService/confirm.service.ts'
import equipmentModelsApi from '@/pages/Equipment/pages/EquipmentModels/equipmentModels.api.ts'
import equipmentEvents from '@/pages/Equipment/events/equipment/equipment.events.ts'
import SeparateLine from '@/shared/Forms/SeparateLine'
import css from '@/pages/Equipment/pages/EquipmentModels/components/EquipmentModelSidePage/maintenanceBlankSidePage.module.css'
import timeUtils from '@/utils/time.utils.ts'
import Button from '@/shared/Buttons/Button'
import { IEquipmentModel } from '@/pages/Equipment/pages/EquipmentModels/equipmentModels.types.ts'
import ProtectedContent from '@/services/rights/ProtectedContent'

interface IProps {
  modelId: IEquipmentModel['id']
  onClose: () => void
  onEdit: () => void
}

const ViewEquipmentModelSidePageContent = (props: IProps) => {
  const model = useEquipmentModel(props.modelId)

  const handleRemove = () => {
    confirmService.requestConfirm({
      description: `Подтвердите удаление модели ${model.name}`,
      buttonType: 'primary',
      onConfirm: () =>
        equipmentModelsApi
          .deleteModel(props.modelId)
          .then((r) => r.status === 'success' && equipmentEvents.modelDeleted(r.body.id))
          .then(() => props.onClose()),
    })
  }

  return (
    <div className="flex-lines gap16" style={{ height: '100%' }}>
      <h2 className="text-heading-4" style={{ width: '90%' }}>
        Модель "{model?.name}"
      </h2>
      <SeparateLine />
      <div className={css.sidePageGrid}>
        <p className="text-nm text-secondary">Дата создания:</p>
        <p className="text-nm">{timeUtils.formatDate(new Date(model?.createdAt), 'dd MMM yyyy')}</p>
        <p className="text-nm text-secondary">Дата обновления:</p>
        <p className="text-nm">{timeUtils.formatDate(new Date(model?.updatedAt), 'dd MMM yyyy')}</p>
      </div>

      <div style={{ marginTop: 'auto' }}>
        <SeparateLine />
      </div>
      <div className="inline-flex-gap gap8">
        <ProtectedContent requiredRight="equipment:update">
          <Button size="default" type="default" text="Редактировать" onClick={props.onEdit} />
        </ProtectedContent>
        <ProtectedContent requiredRight="equipment:delete">
          <Button size="default" type="default" text="Удалить" danger={true} onClick={handleRemove} />
        </ProtectedContent>
      </div>
    </div>
  )
}

export default ViewEquipmentModelSidePageContent
